import { oldmap } from '~/apis/oldmap'

export default defineNuxtRouteMiddleware(async (to) => {
  const oldRegex = /[0-9]*.html$/
  const isOld = oldRegex.test(to.path)
  if (isOld) {
    const id = parseInt(to.path.substring(1))
    const res = await oldmap(id)
    if (res.code === 1) {
      const resource = res.data.data
      switch (resource.resource_type) {
        case 0:
          return navigateTo(`/article/${resource.resource_id}`, {
            redirectCode: 301
          })
        case 1:
          return navigateTo(`/video/${resource.resource_id}`, {
            redirectCode: 301
          })
        default:
          break
      }
    }
  }

  const nuxtApp = useNuxtApp()
  let host = ''
  let url = ''
  if (process.server) {
    host = nuxtApp.ssrContext?.event.node.req.headers.host || ''
  } else {
    host = window.location.host
  }
  if (to.fullPath === '/') {
    return
  }
  const mlinkRegex = /^m[avf][0-9]*/
  const path = to.fullPath.substring(1)
  const ismlink = mlinkRegex.test(path)
  if (ismlink) {
    const type = path.slice(0, 2) as 'mv' | 'ma'
    const id = path.slice(2)
    const map = {
      mv: 'video',
      ma: 'article'
      // 暂时移除mf，mf后续作为旧站内容序号访问使用
    }
    const newPath = map[type]
    url = `/${newPath}/${id}`
    return navigateTo(url)
  }
})
